import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { hidePassChange, changePassword } from "../../actions/user";

const emptyForm = { password: "", newpassword1: "", newpassword2: "" };

const UserPasswordChange = ({ isShowing, hidePassChange, changePassword }) => {
  const [formData, setFormData] = useState(emptyForm);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Passwords never outlive the popup.
  useEffect(() => {
    if (!isShowing) {
      setFormData(emptyForm);
      setShowCurrent(false);
      setShowNew(false);
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        hidePassChange();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isShowing, hidePassChange]);

  if (!isShowing) {
    return null;
  }

  const { password, newpassword1, newpassword2 } = formData;
  const passwordsMismatch = newpassword2 !== "" && newpassword1 !== newpassword2;
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (newpassword1 !== newpassword2) {
      toastr.error("Шинэ нууц үг хоорондоо таарахгүй байна");
      return;
    }
    setIsSubmitting(true);
    await changePassword(password, newpassword1);
    setIsSubmitting(false);
  };

  const toggleButton = (shown, setShown) => (
    <button
      type="button"
      className="dialog-password-toggle"
      aria-label={shown ? "Нууц үгийг нуух" : "Нууц үгийг харуулах"}
      aria-pressed={shown}
      onClick={() => setShown(!shown)}
    >
      <i
        className={`fas ${shown ? "fa-eye-slash" : "fa-eye"}`}
        aria-hidden="true"
      ></i>
    </button>
  );

  return (
    <div className="modal is-active dialog-modal">
      <div className="modal-background" onClick={hidePassChange}></div>
      <div className="modal-content">
        <div
          className="dialog-box"
          role="dialog"
          aria-modal="true"
          aria-labelledby="password-change-title"
        >
          <button
            type="button"
            className="dialog-close"
            aria-label="Хаах"
            onClick={hidePassChange}
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>

          <span className="dialog-icon" aria-hidden="true">
            <i className="fas fa-key"></i>
          </span>
          <h2 id="password-change-title">Нууц үг солих</h2>
          <p className="dialog-lead">
            Одоогийн нууц үгээ оруулаад шинэ нууц үгээ хоёр удаа бичнэ үү.
          </p>

          <form onSubmit={onSubmit}>
            <div className="field">
              <label className="dialog-label" htmlFor="password-current">
                Одоогийн нууц үг
              </label>
              <div className="control has-icons-left">
                <input
                  id="password-current"
                  type={showCurrent ? "text" : "password"}
                  className="input dialog-password-input"
                  name="password"
                  value={password}
                  autoComplete="current-password"
                  autoFocus
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-lock" aria-hidden="true"></i>
                </span>
                {toggleButton(showCurrent, setShowCurrent)}
              </div>
            </div>

            <div className="field">
              <label className="dialog-label" htmlFor="password-new">
                Шинэ нууц үг
              </label>
              <div className="control has-icons-left">
                <input
                  id="password-new"
                  type={showNew ? "text" : "password"}
                  className="input dialog-password-input"
                  name="newpassword1"
                  value={newpassword1}
                  placeholder="Хамгийн багадаа 6 тэмдэгт"
                  autoComplete="new-password"
                  minLength={6}
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-lock" aria-hidden="true"></i>
                </span>
                {toggleButton(showNew, setShowNew)}
              </div>
            </div>

            <div className="field">
              <label className="dialog-label" htmlFor="password-new2">
                Шинэ нууц үгээ давтах
              </label>
              <div className="control has-icons-left">
                <input
                  id="password-new2"
                  type={showNew ? "text" : "password"}
                  className={`input ${passwordsMismatch ? "is-danger" : ""}`}
                  name="newpassword2"
                  value={newpassword2}
                  autoComplete="new-password"
                  aria-invalid={passwordsMismatch}
                  aria-describedby={
                    passwordsMismatch ? "password-new2-help" : undefined
                  }
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-lock" aria-hidden="true"></i>
                </span>
              </div>
              {passwordsMismatch && (
                <p id="password-new2-help" className="dialog-help">
                  Нууц үгүүд хоорондоо таарахгүй байна.
                </p>
              )}
            </div>

            <button
              type="submit"
              className={`button is-fullwidth dialog-submit ${
                isSubmitting ? "is-loading" : ""
              }`}
              disabled={isSubmitting}
            >
              Нууц үг солих
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

UserPasswordChange.propTypes = {
  isShowing: PropTypes.bool,
  hidePassChange: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
};

export default connect(null, { hidePassChange, changePassword })(
  UserPasswordChange
);
